import React, {useState} from 'react';
import Employe from './Employe/Employe';
import Tache from './Tache/Tache';
import Facture from './Facture/Facture';
import './Administration.css';

/**
 * La vue de l'administration
 * @param {*} props props
 * @return {JSX}
 */
function AdministrationView(props) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [whatToShow, setWhatToShow] = useState('1');

  /**
   * Dropdown pour sélectionner la page
   * @param {*} event event
   */
  function toggleDropdown(event) {
    setShowDropdown(event.target.value);
    setWhatToShow(event.target.value);
  }

  const windowWidth = window.innerWidth;
  const isMobile = windowWidth <= 600;

  return (
    <React.Fragment>
      {localStorage.getItem('admin') === '1' ?
    <div className="admin-container">
      <h1 className="admin-h1">Administration</h1>
      <div className="admin-buttons-container">
        {isMobile ? (
        <select className="admin-mobile-select"
          value={showDropdown}
          onChange={(event) => {
            toggleDropdown(event);
          }}>
          <option value={1}>Employés</option>
          <option value={2}>Tâches</option>
          <option value={3}>Factures</option>
        </select>
      ) : (
        <div className="admin-buttons2">
          <button
            className={whatToShow === '1' ? 'admin-button2selected' : 'admin-button2'}
            value={1}
            onClick={(event) => toggleDropdown(event)}>Employés</button>
          <button
            className={whatToShow === '2' ? 'admin-button2selected' : 'admin-button2'}
            value={2}
            onClick={(event) => toggleDropdown(event)}>Tâches</button>
          <button
            className={whatToShow === '3' ? 'admin-button2selected' : 'admin-button2'}
            value={3}
            onClick={(event) => toggleDropdown(event)}>Factures</button>
        </div>
      )}

      </div>
      {whatToShow === '1' ?
      <Employe employes={props.employes} setEmployes={props.setEmployes}/> :
       whatToShow === '2' ? <Tache taches={props.taches} setTaches={props.setTaches}/> :
        <Facture factures={props.factures} setFactures={props.setFactures}/>}
    </div> : '' }
    </React.Fragment>
  );
}

export default AdministrationView;
